<template>
  <b-card title="Issued Cheques">
    <cheque-filter @filtersUpdated="filtersChangeHandler" />
    <cheque-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import ChequeList from '../../components/IssuedCheques/ChequeList.vue'
import ChequeFilter from '../../components/IssuedCheques/ChequeFilter.vue'

export default {
  components: {
    BCard,
    ChequeList,
    ChequeFilter,
  },
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}

</script>
